import { render, staticRenderFns } from "./AtomicEmissionSpectroscopySIM.vue?vue&type=template&id=83935900&"
import script from "./AtomicEmissionSpectroscopySIM.vue?vue&type=script&lang=ts&"
export * from "./AtomicEmissionSpectroscopySIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports